'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  .ant-badge-count {\n    right: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _Icons = require('shared/components/Icons');

var _Icons2 = _interopRequireDefault(_Icons);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('../../../styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BadgeStyled = (0, _styledComponents2.default)(_antd.Badge)(_templateObject());

var NotificationBadge = function NotificationBadge(_ref) {
  var count = _ref.count,
      className = _ref.className,
      iconStyles = _ref.iconStyles;
  return _react2.default.createElement('span', {
    className: className
  }, count ? _react2.default.createElement(BadgeStyled, {
    count: count,
    overflowCount: 9999
  }, _react2.default.createElement(_Icons2.default.bell, {
    style: _extends({}, iconStyles, {
      marginRight: 0
    })
  })) : _react2.default.createElement(_Icons2.default.bell, {
    style: _extends({}, iconStyles, {
      marginRight: 0,
      marginTop: '5px'
    })
  }));
};

NotificationBadge.propTypes = {
  count: _propTypes2.default.number
};
NotificationBadge.defaultProps = {
  count: 0
};
NotificationBadge.displayName = 'NotificationBadge';
exports.default = NotificationBadge;